import axios from 'axios';
import auth from './auth';

//axios default values
axios.defaults.baseURL = process.env.BACKEND_API_BASE_URL

function setHeaders() {
    var jwtToken = auth.auth.getSignInUserSession().getIdToken().jwtToken;
    var requestHeaders = {
        headers: {
            'Authorization': 'Bearer ' + jwtToken
        }
    }
    return requestHeaders
};

export default {
    async getDomainList() {
        const response = axios
            .get('/info/domains', setHeaders())
        return (await response).data;
    },
    async setDomainList(domain) {
        var data = '{"domain":"' + domain + '"}'
        const response = axios
            .post('/info/domains', data, setHeaders())
        return (await response).data;
    },
    async setKillswitchForDomain(killswitch, id) {
        // Send the request
        var data = '{"id":"' + id + '","killswitch":' + killswitch + '}'
        const response = axios
            .post('/campaign/killswitch', data, setHeaders())
        return (await response).data;
    },
    async setSettingsDetails(customer_name, default_domain_index, email_notifications) {
        // Send the request
        var data = '{"customer_name":"' + customer_name + '","default_domain_index":' + default_domain_index + ',"email_notifications":' + email_notifications + '}'
        const response = axios
            .post('/settings', data, setHeaders())
        return (await response).data;
    },
    async setUpDownForDomain(id, status) {
        // Send the request
        var data = '{"id":"' + id + '","up":' + status + '}'
        const response = axios
            .post('/campaign/status', data, setHeaders())
        return (await response).data;
    },
    async getNotifications() {
        const response = axios
            .get('/notifications', setHeaders())
        return (await response).data;
    },
    async getAllNotifications() {
        const response = axios
            .get('/notifications/all', setHeaders())
        return (await response).data;
    },
    async markAllNotificationsRead() {
        var data = '{"id":"all"}'
        const response = axios
            .post('/notifications', data, setHeaders())
        return (await response).data;
    },
    async markNotificationRead(id) {
        var data = '{"id" : "' + id + '"}'
        const response = axios
            .post('/notifications', data, setHeaders())
        return (await response).data;
    },
    async getPhishingWebsites(domain, period) {
        const response = axios
            .get('/info/campaigns?domain=' + domain + '&interval=' + period, setHeaders())
        return (await response).data;
    },
    async addPhishingWebsite(domain, url, original) {
        var data = '{"domain" : "' + domain + '","url" : "' + url + '","original" : "' + original + '"}'
        const response = axios
            .post('/campaign/add/', data, setHeaders())
        return (await response).data;
    },
    async deletePhishingWebsites(ids) {
        var data = '{"domains" : ' + ids + '}'
        const response = axios
            .post('/campaign/delete/', data, setHeaders())
        return (await response).data;
    },
    async updateStatusPhishingWebsites(ids, status) {
        var data = '{"domains" : ' + ids + ',"status":"' + status + '"}'
        const response = axios
            .post('/campaign/status/', data, setHeaders())
        return (await response).data;
    },
    async getDetailsWebsite(id) {
        const response = axios
            .get('campaign/details?id=' + id, setHeaders())
        return (await response).data;
    },
    async addCommentWebsite(id, comment) {
        var data = '{"id" : "' + id + '","comment":"' + comment + '"}'
        const response = axios
            .post('/campaign/details/comment', data, setHeaders())
        return (await response).data;
    },
    async getSettingsDetails() {
        const response = axios
            .get('/settings', setHeaders())
        return (await response).data;
    },
    async getBillingDetails() {
        const response = axios
            .get('/billing', setHeaders())
        return (await response).data;
    },
    async getPlugins() {
        const response = axios
            .get('/marketplace/plugins', setHeaders())
        return (await response).data;
    },
    async enablePlugin(id) {
        var data = '{"id" : "' + id + '"}'
        const response = axios
            .post('/marketplace/plugin/buy', data, setHeaders())
        return (await response).data;
    },
    async getPluginSettings(id) {
        var data = '{"id" : "' + id + '"}'
        const response = axios
            .post('/marketplace/plugin/settings', data, setHeaders())
        return (await response).data;
    },
    async setPluginSettings(id, settings) {
        var data = '{"id" : "' + id + '", "settings" : ' + settings + '}'
        const response = axios
            .put('/marketplace/plugin/settings', data, setHeaders())
        return (await response).data;
    },
    async disablePlugin(id) {
        var data = '{"id" : "' + id + '"}'
        const response = axios
            .post('/marketplace/plugin/delete', data, setHeaders())
        return (await response).data;
    },
    async getStatisticsDomain(domain, period) {
        const response = axios
            .get('/report/statistics?interval=' + period + '&domain=' + domain, setHeaders())
        return (await response).data;
    },
    async getPhishingEmails() {
        const response = axios
            .get('/email/dashboard/emails?interval=y', setHeaders())
        return (await response).data;
    },
    async getStatisticsEmail() {
        const response = axios
            .get('/email/dashboard/stats?interval=y', setHeaders())
        return (await response).data;
    },
    async generateReport(domain, period, format) {
        //force location href - bad solution
        ///window.location.href = BASE_API_URL + '/dev/api/report?interval='+ period +'&domain='+ domain + '&format=' + format
        const response = axios
            .get('/report?interval=' + period + '&domain=' + domain +
                '&format=' + format, setHeaders())
        this.forceFileDownload(await response, format);
    },
    async getJavascriptForDomain(domain) {
        const response = axios
            .get('/agent/download?domain=' + domain, setHeaders())
        return (await response).data;
    },
    async forceFileDownload(response, format) {
        if (format == "json")
            response.data = JSON.stringify(response.data)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.' + format) //or any other extension
        document.body.appendChild(link)
        link.click()
    },
    async forceJsFileDownload(response, filename) {
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
    },
    async getUserInfo() {
        const USERINFO_URL = 'https://' + auth.auth.getAppWebDomain() + '/oauth2/userInfo';
        var requestData = {
            headers: {
                'Authorization': 'Bearer ' + jwtToken
            }
        }
        const response = await axios.get(USERINFO_URL, requestData);
        return response.data;
    },

    async getCustomers() {
        const response = axios
            .get('/billing/stripe/customer', setHeaders())
        return (await response).data;
    },

    async getSubscriptions() {
        const response = axios
            .get('/billing/stripe/subscriptions', setHeaders())
        return (await response).data;
    },

    async getInvoices(subscriptionId) {
        const response = axios
            .get('/billing/stripe/invoices?subscription=' + subscriptionId, setHeaders())
        return (await response).data;
    },
    async getSubmissionList(id) {
        const response = axios
            .get('/submission/?domain_id=' + id, setHeaders())
        return (await response).data;
    },
    async submitPhishingDomain(id) {
        let data = ""
        const response = axios
            .post('/submission/?domain_id=' + id, data, setHeaders())
        return (await response).data;
    },
    async deployWorkflow(id) {
        var data = '{"id" : "' + id + '"}'
        const response = axios
            .post('orchestration/workflow/deploy', data, setHeaders())
        return (await response).data;
    },
    async executeWorkflow(id) {
        var data = '{"id" : "' + id + '"}'
        const response = axios
            .post('orchestration/workflow/execute', data, setHeaders())
        return (await response).data;
    },
    async getWorkflowExecutions(id) {
        const response = axios
            .get('orchestration/workflow/execution/list/?id=' + id, setHeaders())
        return (await response).data;
    },
    async getWorkflowExecutionDetails(id, name) {
        const response = axios
            .get('orchestration/workflow/execution/details/?id=' + id + '&name=' + name, setHeaders())
        return (await response).data;
    },
    async saveWorkflow(json) {
        const response = axios
            .post('orchestration/workflow/save', json, setHeaders())
        return (await response).data;
    },
    async listWorkflows() {
        const response = axios
            .get('orchestration/workflow/list', setHeaders())
        return (await response).data;
    },
    async loadWorkflow(id) {
        const response = axios
            .get('orchestration/workflow/load/?id=' + id, setHeaders())
        return (await response).data;
    },
    async deleteWorkflow(json) {
        const response = axios
            .post('orchestration/workflow/delete/', json, setHeaders())
        return (await response).data;
    },
    async listPlugins() {
        const response = axios
            .get('orchestration/plugins/list', setHeaders())
        return (await response).data;
    },
    async detailsPlugin(id) {
        const response = axios
            .get('orchestration/plugins/details?id=' + id, setHeaders())
        return (await response).data;
    },



    async callEventPlugin(plugin, input) {
        // TODO: call the delegator function and get the response
        // const response = axios
        //         .post('/marketplace/plugin/callPlugin/?plugin=' + plugin, input, setHeaders())
        // return (await response).data;
        let dummy = "{ 'plugin': 'auth0-ip-reputation-check', result: []}"
        return dummy

    }
}